import loadable from '@loadable/component';

const PoliDetailLoadable = loadable(() => import(/* webpackChunkName: "poli-detail-page" */ './index'));

export default PoliDetailLoadable;
